import * as React from "react"
import Logo from "../Logo/Logo"

const LandingPageCheckrSignup = ({ headerLogo }) => {
  const signupLink = process.env.GATSBY_CHECKR_SIGNUP_URL
  return (
    <div className="Wrap">
      <div className="Header-logo">
        <div className="Logo">
          <Logo logo={headerLogo} />
        </div>
      </div>

      <div className={`Header-cta checkr-signup-link`}>
        <a
          href={`${signupLink}`}
          className="Button is-default is-small"
        >
          Create Account Now
        </a>
      </div>
    </div>
  )
}

export default LandingPageCheckrSignup
